{
  "credits": "{{count}} ECTS",
  "partTime": "Part-time",
  "showAll": "Show all",
  "legend": {
    "courses": "Core courses",
    "modules": "Module",
    "webinars": "Webinar",
    "electives": "Elective"
  },
  "courseDescription": {
    "back": "Back",
    "close": "Close",
    "courseContent": "Course Content",
    "disclaimer": "Disclaimer",
    "disclaimerText": "This is an excerpt from the complete course description for the course. If you are an active student at BI, you can find the complete course descriptions with information on eg. learning goals, learning process, curriculum and exam at portal.bi.no. We reserve the right to make changes to this description.",
    "error": "Something went wrong",
    "errorText": "Failed to load course description, it might not be ready yet. Please try again later.",
    "introduction": "Introduction",
    "label": "Course",
    "loading": "Loading course description...",
    "opportunities": {
      "title": "Opportunities during your studies",
      "empty": "Data is missing, please check again later",
      "electives": {
        "chipsHeader": "Electives like",
        "empty": "No courses found"
      }
    }
  }
}
